import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { useChildDetails } from '@sola/my-sdk/children/hooks.ts';
import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
const getChildName = (child: ChildDetails) => child.name.preferred || child.name.first;
interface SpotlightCardDepartureData {
  childImageUrl?: string | null;
  childName: string;
  titleKey: string;
}
export const useSpotlightCardDeparture = (globalId, unexpected) => {
  const $ = _c(8);
  const {
    t
  } = useTranslation("my");
  const childDetails = useChildDetails(globalId);
  const hasError = childDetails.isError || !childDetails.data;
  const titleKey = unexpected ? "my:sponsorshipRelationship.departures.spotlight.departure.unexpectedTitle" : "my:sponsorshipRelationship.departures.spotlight.departure.title";
  let t0;
  if ($[0] !== childDetails.data || $[1] !== titleKey) {
    t0 = childDetails.data ? {
      childImageUrl: childDetails.data.imageUrl,
      childName: getChildName(childDetails.data),
      titleKey
    } : undefined;
    $[0] = childDetails.data;
    $[1] = titleKey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const cardData = t0;
  let t1;
  if ($[3] !== cardData || $[4] !== childDetails.isLoading || $[5] !== hasError || $[6] !== t) {
    t1 = {
      t,
      isLoading: childDetails.isLoading,
      hasError,
      cardData
    };
    $[3] = cardData;
    $[4] = childDetails.isLoading;
    $[5] = hasError;
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};